(function () {
  function initLandingPage() {
    const hasLandingPage = !!document.querySelector('.cs2-lp-page-start');
    const hasCustomPdp = !!document.querySelector('.cs2-pdp-main');
    if (!hasLandingPage && !hasCustomPdp) return;
    if (hasLandingPage) document.body.classList.add('cs2-landing-template');

    document.querySelectorAll('[data-cs2-offer]').forEach((offer) => {
      if (offer.dataset.initialized === 'true') return;
      offer.dataset.initialized = 'true';

      const variantsEl = offer.querySelector('[data-cs2-variants]');
      const idInput = offer.querySelector('input[name="id"]');
      const priceEls = offer.querySelectorAll('[data-cs2-price]');
      const compareEls = offer.querySelectorAll('[data-cs2-compare]');
      const submit = offer.querySelector('[data-cs2-submit]');
      const mainImage = offer.querySelector('.cs2-lp-offer__main-image');
      const mainImageWrap = offer.querySelector('[data-cs2-main-gallery]');
      const galleryPrev = offer.querySelector('[data-cs2-gallery-prev]');
      const galleryNext = offer.querySelector('[data-cs2-gallery-next]');
      const galleryBadge = offer.querySelector('[data-cs2-gallery-badge]');
      const productTitle = offer.querySelector('[data-cs2-product-title]');
      const flavorGroup = offer.querySelector('.cs2-lp-offer__option-group--flavor');
      const skioPicker = offer.querySelector('[data-cs2-skio-picker], skio-plan-picker');
      const supplementDialog = offer.querySelector('[data-cs2-supplement-dialog]');
      const supplementOpen = offer.querySelector('[data-cs2-supplement-open]');
      const supplementClose = offer.querySelector('[data-cs2-supplement-close]');
      const sectionRoot = offer.closest('#cs2-offer.cs2-pdp-main');
      const stickyAtc = sectionRoot?.querySelector('[data-cs2-sticky-atc]');
      const stickySubmit = stickyAtc?.querySelector('[data-cs2-sticky-submit]');
      const stickyTrigger = offer.querySelector('.cs2-pdp-main__video-section');


      function initPdpVideoCards() {
        offer.querySelectorAll('[data-cs2-pdp-video-card]').forEach((card) => {
          if (card.dataset.cs2PdpVideoReady === 'true') return;
          card.dataset.cs2PdpVideoReady = 'true';
          const video = card.querySelector('video.cs2-pdp-main__video');
          const play = card.querySelector('[data-cs2-pdp-video-play]');
          const shell = card.querySelector('.cs2-pdp-main__video-shell');
          const poster = card.querySelector('.cs2-pdp-main__video-poster');
          if (!video || !play || !shell) return;

          // PDP-only interaction: keep native controls out of the way and make the
          // entire video surface a reliable play/pause target on desktop and mobile.
          video.controls = false;
          video.removeAttribute('controls');
          card.classList.remove('is-playing');
          shell.style.cursor = 'pointer';

          const setPausedUi = () => {
            card.classList.remove('is-playing');
            play.setAttribute('aria-label', 'Resume video');
          };

          const start = () => {
            if (poster) poster.style.display = 'none';
            video.controls = false;
            video.removeAttribute('controls');
            card.classList.add('is-playing');
            play.setAttribute('aria-label', 'Pause video');
            const promise = video.play();
            if (promise && typeof promise.catch === 'function') {
              promise.catch(() => {
                setPausedUi();
              });
            }
          };

          const toggle = () => {
            if (video.paused || video.ended) {
              start();
            } else {
              video.pause();
            }
          };

          play.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            toggle();
          });

          shell.addEventListener('click', (event) => {
            if (event.target.closest('[data-cs2-pdp-video-play]')) return;
            event.preventDefault();
            toggle();
          });

          video.addEventListener('play', () => {
            if (poster) poster.style.display = 'none';
            video.controls = false;
            video.removeAttribute('controls');
            card.classList.add('is-playing');
            play.setAttribute('aria-label', 'Pause video');
          });

          video.addEventListener('pause', () => {
            if (!video.ended) setPausedUi();
          });

          video.addEventListener('ended', () => {
            setPausedUi();
          });
        });
      }

      initPdpVideoCards();

      function configureSkioPicker() {
        if (!skioPicker) return;
        const apply = () => {
          const offerStyles = getComputedStyle(offer);
          const gap = offerStyles.getPropertyValue('--cs2-purchase-stack-gap').trim() || '10px';
          skioPicker.style.setProperty('--cs2-purchase-stack-gap', gap);
          skioPicker.style.setProperty('--cs2-skio-frequency-gap', offerStyles.getPropertyValue('--cs2-skio-frequency-gap').trim() || '0px');
          const root = skioPicker.shadowRoot;
          if (root && !root.querySelector('style[data-cs2-landing-skio]')) {
            const style = document.createElement('style');
            style.dataset.cs2LandingSkio = 'true';
            style.textContent = `
              .skio-plan-picker{gap:var(--cs2-purchase-stack-gap,10px)!important;margin:0!important;font-family:inherit!important}
              .group-container{overflow:hidden;box-sizing:border-box!important;width:100%!important;max-width:100%!important;border-radius:12px!important;box-shadow:none!important;transition:border-color .2s ease,background-color .2s ease}
              .group-container--selected{box-shadow:0 8px 24px rgba(124,92,255,.08)!important}
              .group-label{box-sizing:border-box!important;width:100%!important;max-width:100%!important;padding:14px 16px!important}
              .group-container--selected .group-label{padding-bottom:5px!important}
              .group-container--selected .group-content{margin-top:var(--cs2-skio-frequency-gap,0px)!important}
              .group-topline{gap:10px!important;align-items:flex-start!important;min-width:0!important;width:100%!important}
              .group-title{font-size:1.18em!important;line-height:1.2!important;font-weight:800!important;max-width:none!important;min-width:0!important;flex:1 1 auto!important;display:flex!important;align-items:center!important;gap:6px!important;flex-wrap:wrap!important}
              .skio-price{flex:0 0 auto!important;min-width:0!important;font-size:1.08em!important;font-weight:750!important;line-height:1.1!important}
              .skio-price s{font-size:.82em!important;opacity:.55!important}
              .group-container--selected .skio-radio__container{color:var(--cs2-skio-benefit-accent,#7c5cff)!important}
              .savings.bubble{background:var(--cs2-skio-benefit-accent,#7c5cff)!important;border-color:var(--cs2-skio-benefit-accent,#7c5cff)!important;color:#fff!important;border-radius:6px!important;padding:3px 9px!important;font-size:.72em!important;font-weight:800!important;vertical-align:middle!important}
              .group-content.margin-left{margin-left:34px!important}
              .selling-plan-dropdown{margin-top:0!important;padding:7px 32px 7px 11px!important;background-color:rgba(255,255,255,.72)!important;border:1.5px solid currentColor!important;border-radius:8px!important;font-size:.88em!important;color:inherit!important;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23111111' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m6 9 6 6 6-6'/%3E%3C/svg%3E")!important}
              .group-content-additional{margin-top:9px!important;padding-top:9px!important;border-top:1px solid rgba(17,17,17,.12)!important}
              .group-content-additional ul{list-style:none!important;margin:0!important;padding:0!important;display:grid!important;gap:7px!important}
              .group-content-additional li{position:relative!important;margin:0!important;padding-left:25px!important;color:inherit!important;font-size:var(--cs2-skio-benefit-size,15px)!important;line-height:1.25!important;font-weight:550!important}
              .group-content-additional li::before{content:'✓';position:absolute;left:0;top:-1px;color:var(--cs2-skio-benefit-accent,#7c5cff)!important;font-size:1.15em!important;font-weight:900!important}
              .group-content-additional li:first-child{font-weight:800!important}
              .group-container--last .group-label{padding-top:12px!important;padding-bottom:12px!important}
              @media(max-width:768px){
                .group-label{padding:10px 9px!important}
                .group-container--selected .group-label{padding-bottom:4px!important}
                .group-container--selected .group-content{margin-top:var(--cs2-skio-frequency-gap,0px)!important}
                .selling-plan-dropdown{margin-top:0!important}
                .group-topline{gap:6px!important}
                .group-title{font-size:1em!important;gap:5px!important}
                .savings.bubble{padding:3px 7px!important;font-size:.68em!important}
                .skio-price{font-size:1em!important}
                .group-content.margin-left{margin-left:30px!important}
                .group-content-additional{margin-top:8px!important;padding-top:8px!important}
                .group-content-additional ul{gap:6px!important}
                .group-content-additional li{font-size:calc(var(--cs2-skio-benefit-size,15px) - 1px)!important;padding-left:22px!important}
              }
            `;
            root.appendChild(style);
          }
          updateSkioEnhancements();
        };
        if (customElements.get('skio-plan-picker')) apply();
        else customElements.whenDefined('skio-plan-picker').then(apply).catch(() => {});
      }

      function currentPackSize() {
        const group = offer.querySelector('.cs2-lp-offer__option-group--size');
        const button = group ? group.querySelector('[data-option-value].is-selected') : null;
        const match = String(button?.dataset.optionValue || '').match(/\b(30|60|90)\b/);
        return match ? Number(match[1]) : null;
      }

      function syncStickyAtc() {
        if (!stickyAtc) return;
        if (stickySubmit) stickySubmit.disabled = false;
      }

      function updateStickyAtcVisibility() {
        if (!stickyAtc || !sectionRoot) return;
        // Show as soon as the PDP video section reaches the top of the viewport.
        // If videos are disabled, fall back to the original end-of-product-section trigger.
        const shouldShow = stickyTrigger
          ? stickyTrigger.getBoundingClientRect().top <= 0
          : sectionRoot.getBoundingClientRect().bottom <= 0;
        stickyAtc.classList.toggle('is-visible', shouldShow);
        stickyAtc.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      function initStickyAtc() {
        if (!stickyAtc || stickyAtc.dataset.cs2StickyReady === 'true') return;
        stickyAtc.dataset.cs2StickyReady = 'true';
        if (stickySubmit) {
          stickySubmit.addEventListener('click', () => {
            const target = flavorGroup || offer;
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
        let ticking = false;
        const requestVisibilityUpdate = () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => {
            ticking = false;
            updateStickyAtcVisibility();
          });
        };
        window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
        window.addEventListener('resize', requestVisibilityUpdate, { passive: true });
        syncStickyAtc();
        updateStickyAtcVisibility();
      }

      function currentDiscountPercent(pack) {
        try {
          if (skioPicker?.selectedSellingPlan && typeof skioPicker.discount === 'function') {
            const value = Number(skioPicker.discount(skioPicker.selectedSellingPlan)?.percent || 0);
            if (value > 0) return Math.round(value);
          }
        } catch (e) {}
        return pack === 90 ? 36 : pack === 60 ? 28 : 15;
      }

      function subscriptionGroup() {
        if (!skioPicker?.shadowRoot) return null;
        const groups = [...skioPicker.shadowRoot.querySelectorAll('.group-container')];
        return groups.find((group) => /subscribe/i.test(group.querySelector('.group-title')?.textContent || ''))
          || groups.find((group) => !/one\s*time/i.test(group.querySelector('.group-title')?.textContent || ''))
          || null;
      }


      function updateTrustBadge() {
        // Skio's selectedSellingPlan is the source of truth. The hidden selling_plan
        // input and rendered group classes can briefly be stale while Lit re-renders,
        // which caused the subscription badge to remain visible after selecting one-time.
        const subscribed = !!skioPicker?.selectedSellingPlan;
        const trust = offer.querySelector('[data-cs2-trust-three]');
        if (!trust) return;
        const label = trust.querySelector('[data-cs2-trust-three-label]');
        const oneIcon = trust.querySelector('[data-cs2-trust-icon-onetime]');
        const subIcon = trust.querySelector('[data-cs2-trust-icon-subscription]');
        if (label) label.textContent = subscribed ? (label.dataset.subscription || 'Free Shipping') : (label.dataset.onetime || 'Clinically Dosed');
        if (oneIcon) {
          oneIcon.hidden = subscribed;
          oneIcon.style.display = subscribed ? 'none' : 'inline-flex';
        }
        if (subIcon) {
          subIcon.hidden = !subscribed;
          subIcon.style.display = subscribed ? 'inline-flex' : 'none';
        }
        syncStickyAtc();
      }


      function frequencyMatches(text, pack) {
        const value = String(text || '').toLowerCase().replace(/[-_]/g, ' ').replace(/\s+/g, ' ').trim();
        if (pack === 30) return /monthly/.test(value) || /every\s+(1\s+)?month/.test(value) || /4\s*weeks?/.test(value) || /30\s*days?/.test(value);
        if (pack === 60) return /every\s+2\s+months?/.test(value) || /2\s+months?/.test(value) || /8\s*weeks?/.test(value) || /60\s*days?/.test(value);
        if (pack === 90) return /every\s+3\s+months?/.test(value) || /3\s+months?/.test(value) || /12\s*weeks?/.test(value) || /90\s*days?/.test(value);
        return false;
      }

      function relabelFrequencyOptions(dropdown) {
        if (!dropdown || !dropdown.options?.length) return;
        [...dropdown.options].forEach((option) => {
          const raw = option.textContent;
          if (frequencyMatches(raw, 30)) option.textContent = 'Ships Every 30 Days';
          else if (frequencyMatches(raw, 60)) option.textContent = 'Ships Every 60 Days';
          else if (frequencyMatches(raw, 90)) option.textContent = 'Ships Every 90 Days';
        });
      }

      let lastFrequencyPack = null;
      function ensureDefaultFrequency(pack) {
        if (!skioPicker?.shadowRoot || !pack) return;
        const group = subscriptionGroup();
        if (!group) return;
        const content = group.nextElementSibling;
        const dropdown = content?.querySelector?.('.selling-plan-dropdown') || skioPicker.shadowRoot.querySelector('.selling-plan-dropdown');
        if (!dropdown || !dropdown.options?.length) return;
        relabelFrequencyOptions(dropdown);
        const target = [...dropdown.options].find((option) => frequencyMatches(option.textContent, pack));
        if (!target) return;
        if (dropdown.value !== target.value) {
          dropdown.value = target.value;
          dropdown.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
        }
        const desiredLabel = `Ships Every ${pack} Days`;
        if (target.textContent !== desiredLabel) target.textContent = desiredLabel;
        lastFrequencyPack = pack;
      }

      function updateSkioEnhancements() {
        if (!skioPicker?.shadowRoot) return;
        const pack = currentPackSize() || 30;
        updateTrustBadge();
        ensureDefaultFrequency(pack);
        window.requestAnimationFrame(syncStickyAtc);
      }

      function syncSkioVariant(variant) {
        if (!skioPicker || !variant) return;
        const applyWhenReady = (attempt = 0) => {
          const sourceVariants = skioPicker.product && Array.isArray(skioPicker.product.variants) ? skioPicker.product.variants : [];
          if (!sourceVariants.length && skioPicker.productHandle && attempt < 50) {
            window.setTimeout(() => applyWhenReady(attempt + 1), 100);
            return;
          }
          const fullVariant = sourceVariants.find((item) => String(item.id) === String(variant.id)) || variant;
          skioPicker.selectedVariant = fullVariant;
          skioPicker.variantChanged = true;
          if (typeof skioPicker.requestUpdate === 'function') skioPicker.requestUpdate();
          window.setTimeout(updateSkioEnhancements, 80);
          window.setTimeout(updateSkioEnhancements, 220);
        };
        if (customElements.get('skio-plan-picker')) applyWhenReady();
        else customElements.whenDefined('skio-plan-picker').then(() => applyWhenReady()).catch(() => {});
      }
      if (!variantsEl || !idInput) return;

      let variants = [];
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
      let selected = [];
      configureSkioPicker();
      if (skioPicker) {
        customElements.whenDefined('skio-plan-picker').then(() => {
          const attach = (attempt = 0) => {
            if (!skioPicker.shadowRoot) {
              if (attempt < 50) window.setTimeout(() => attach(attempt + 1), 100);
              return;
            }
            if (!skioPicker.__cs2EnhancementObserver) {
              const observer = new MutationObserver(() => window.requestAnimationFrame(() => { updateSkioEnhancements(); syncStickyAtc(); }));
              observer.observe(skioPicker.shadowRoot, { childList: true, subtree: true, attributes: true });
              skioPicker.__cs2EnhancementObserver = observer;
            }
            const sellingPlanInput = skioPicker.querySelector('input[name="selling_plan"]');
            if (sellingPlanInput && !sellingPlanInput.__cs2TrustBound) {
              sellingPlanInput.addEventListener('change', () => window.requestAnimationFrame(updateTrustBadge));
              sellingPlanInput.__cs2TrustBound = true;
            }
            if (!skioPicker.__cs2TrustPlanEventBound) {
              skioPicker.addEventListener('skio::update-selling-plan', () => window.requestAnimationFrame(() => { updateTrustBadge(); syncStickyAtc(); }));
              skioPicker.__cs2TrustPlanEventBound = true;
            }
            if (!skioPicker.__cs2StickyShadowBound) {
              skioPicker.shadowRoot.addEventListener('change', () => window.setTimeout(syncStickyAtc, 0));
              skioPicker.__cs2StickyShadowBound = true;
            }
            updateSkioEnhancements();
          };
          attach();
        }).catch(() => {});
      }

      if (supplementDialog && supplementOpen) {
        supplementOpen.addEventListener('click', () => {
          if (typeof supplementDialog.showModal === 'function') supplementDialog.showModal();
          else supplementDialog.setAttribute('open', '');
        });
        if (supplementClose) supplementClose.addEventListener('click', () => supplementDialog.close());
        supplementDialog.addEventListener('click', (event) => {
          if (event.target === supplementDialog) supplementDialog.close();
        });
      }

      offer.querySelectorAll('[data-option-index]').forEach((group) => {
        const selectedButton = group.querySelector('.is-selected') || group.querySelector('[data-option-value]');
        selected[Number(group.dataset.optionIndex)] = selectedButton ? selectedButton.dataset.optionValue : null;
      });

      function money(cents) {
        const currency = offer.dataset.currency || 'USD';
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
        catch (e) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
      }

      function findVariant() {
        return variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
      }

      function normalized(value) {
        return String(value || '').trim().toLowerCase();
      }

      function canonicalFlavor(value) {
        const text = normalized(value).replace(/[^a-z0-9]+/g, ' ').trim();
        if (text.includes('lemon') || text.includes('lime')) return 'lemon-lime';
        if (text.includes('mixed') || text.includes('berry')) return 'mixed-berry';
        return text.replace(/\s+/g, '-');
      }

      function updateGalleryArrows() {
        const thumbs = visibleGalleryThumbs();
        let index = thumbs.findIndex((item) => item.classList.contains('is-active'));
        if (index < 0) index = 0;
        if (galleryPrev) galleryPrev.hidden = thumbs.length < 2 || index <= 0;
        if (galleryNext) galleryNext.hidden = thumbs.length < 2 || index >= thumbs.length - 1;
      }

      function setMainImageFromThumb(thumb, scrollThumb) {
        if (!thumb || !mainImage) return;
        const src = thumb.dataset.imageSrc;
        if (src) {
          mainImage.src = src;
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
        }
        if (thumb.dataset.imageAlt) mainImage.alt = thumb.dataset.imageAlt;
        if (galleryBadge) galleryBadge.hidden = thumb.dataset.galleryHero !== 'true';
        offer.querySelectorAll('[data-cs2-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
        updateGalleryArrows();
        if (scrollThumb && thumb.scrollIntoView) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      function visibleGalleryThumbs() {
        return Array.from(offer.querySelectorAll('[data-cs2-thumb]')).filter((item) => !item.hidden);
      }

      function stepGallery(direction) {
        const thumbs = visibleGalleryThumbs();
        if (thumbs.length < 2) return;
        let index = thumbs.findIndex((item) => item.classList.contains('is-active'));
        if (index < 0) index = 0;
        const nextIndex = index + direction;
        if (nextIndex < 0 || nextIndex >= thumbs.length) return;
        setMainImageFromThumb(thumbs[nextIndex], true);
      }

      if (galleryPrev) galleryPrev.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); stepGallery(-1); });
      if (galleryNext) galleryNext.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); stepGallery(1); });

      if (mainImageWrap) {
        let pointerStartX = null;
        let pointerStartY = null;
        mainImageWrap.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          pointerStartX = event.clientX;
          pointerStartY = event.clientY;
          try { mainImageWrap.setPointerCapture(event.pointerId); } catch (e) {}
        });
        mainImageWrap.addEventListener('pointerup', (event) => {
          if (pointerStartX == null || pointerStartY == null) return;
          const dx = event.clientX - pointerStartX;
          const dy = event.clientY - pointerStartY;
          pointerStartX = null;
          pointerStartY = null;
          if (Math.abs(dx) >= 44 && Math.abs(dx) > Math.abs(dy) * 1.15) stepGallery(dx < 0 ? 1 : -1);
        });
        mainImageWrap.addEventListener('pointercancel', () => { pointerStartX = null; pointerStartY = null; });
        mainImageWrap.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') { event.preventDefault(); stepGallery(1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); stepGallery(-1); }
        });
        let lastHorizontalWheel = 0;
        mainImageWrap.addEventListener('wheel', (event) => {
          if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 18) return;
          event.preventDefault();
          const now = Date.now();
          if (now - lastHorizontalWheel < 260) return;
          lastHorizontalWheel = now;
          stepGallery(event.deltaX > 0 ? 1 : -1);
        }, { passive: false });
      }

      function updateFlavorGallery() {
        const selectedFlavor = flavorGroup
          ? selected[Number(flavorGroup.dataset.optionIndex)]
          : '';
        const selectedKey = normalized(selectedFlavor);
        const items = Array.from(offer.querySelectorAll('[data-cs2-gallery-item]'));
        if (!items.length) return;

        const visible = [];
        items.forEach((item) => {
          const itemFlavor = normalized(item.dataset.galleryFlavor);
          const show = !itemFlavor || !selectedKey || itemFlavor === selectedKey;
          item.hidden = !show;
          if (show) visible.push(item);
        });

        offer.querySelectorAll('[data-cs2-flavor-callout]').forEach((item) => {
          const itemFlavor = normalized(item.dataset.galleryFlavor);
          item.hidden = Boolean(itemFlavor && selectedKey && itemFlavor !== selectedKey);
        });

        if (productTitle && selectedFlavor) productTitle.textContent = selectedFlavor;

        offer.querySelectorAll('[data-cs2-supplement-flavor]').forEach((item) => {
          const itemFlavor = normalized(item.dataset.cs2SupplementFlavor);
          item.hidden = Boolean(itemFlavor && selectedKey && itemFlavor !== selectedKey);
        });

        const active = visible.find((item) => item.classList.contains('is-active'));
        if (active) { updateGalleryArrows(); return; }

        const hero = visible.find((item) => item.dataset.galleryHero === 'true') || visible[0];
        if (hero) setMainImageFromThumb(hero);
      }

      function updateAvailability() {
        offer.querySelectorAll('[data-option-index]').forEach((group) => {
          const index = Number(group.dataset.optionIndex);
          group.querySelectorAll('[data-option-value]').forEach((button) => {
            const candidate = selected.slice();
            candidate[index] = button.dataset.optionValue;
            const possible = variants.some((variant) => variant.available && variant.options.every((value, i) => candidate[i] == null || value === candidate[i]));
            button.classList.toggle('is-unavailable', !possible);
            button.disabled = !possible;
          });
        });
      }

      function notifyVariantChanged(variant) {
        const fire = () => document.dispatchEvent(new CustomEvent('variantChanged', { detail: { variantId: variant.id } }));
        fire();
        window.setTimeout(fire, 150);
      }

      function selectSubscriptionForCta(attempt = 0) {
        if (!skioPicker) return;
        if (!skioPicker.shadowRoot) {
          if (attempt < 40) window.setTimeout(() => selectSubscriptionForCta(attempt + 1), 100);
          return;
        }
        const group = subscriptionGroup();
        if (!group) {
          if (attempt < 40) window.setTimeout(() => selectSubscriptionForCta(attempt + 1), 100);
          return;
        }
        if (!group.classList.contains('group-container--selected')) group.click();
        window.setTimeout(() => {
          updateSkioEnhancements();
          ensureDefaultFrequency(90);
        }, 120);
      }

      function selectPurchaseFromCta(flavor) {
        const requestedFlavor = canonicalFlavor(flavor || 'Mixed Berry');
        const flavorGroupEl = offer.querySelector('.cs2-lp-offer__option-group--flavor');
        const sizeGroupEl = offer.querySelector('.cs2-lp-offer__option-group--size');
        const flavorIndex = flavorGroupEl ? Number(flavorGroupEl.dataset.optionIndex) : -1;
        const sizeIndex = sizeGroupEl ? Number(sizeGroupEl.dataset.optionIndex) : -1;

        const flavorButton = flavorGroupEl
          ? [...flavorGroupEl.querySelectorAll('[data-option-value]')].find((button) => canonicalFlavor(button.dataset.optionValue) === requestedFlavor)
          : null;
        const size90Button = sizeGroupEl
          ? [...sizeGroupEl.querySelectorAll('[data-option-value]')].find((button) => /\b90\b/.test(String(button.dataset.optionValue || '')))
          : null;

        const requestedFlavorValue = flavorButton?.dataset.optionValue || null;
        const requestedSizeValue = size90Button?.dataset.optionValue || null;

        // Resolve the exact clicked flavor + 90-night variant. Availability is deliberately
        // NOT used to switch flavors: a Lemon Lime CTA must never silently become Mixed Berry.
        let targetVariant = variants.find((variant) => {
          const flavorMatches = flavorIndex < 0 || canonicalFlavor(variant.options[flavorIndex]) === requestedFlavor;
          const sizeMatches = sizeIndex < 0 || /\b90\b/.test(String(variant.options[sizeIndex] || ''));
          return flavorMatches && sizeMatches;
        });

        // Fallback to exact selector values if Shopify's option labels differ from the text match.
        if (!targetVariant && (requestedFlavorValue || requestedSizeValue)) {
          targetVariant = variants.find((variant) => {
            const flavorMatches = flavorIndex < 0 || !requestedFlavorValue || variant.options[flavorIndex] === requestedFlavorValue;
            const sizeMatches = sizeIndex < 0 || !requestedSizeValue || variant.options[sizeIndex] === requestedSizeValue;
            return flavorMatches && sizeMatches;
          });
        }

        // Generic CTAs already request Mixed Berry. Only use Mixed Berry as a true final fallback
        // when the requested flavor does not exist in the selector/product at all.
        if (!targetVariant && requestedFlavor !== 'mixed-berry' && !flavorButton) {
          targetVariant = variants.find((variant) => {
            const flavorMatches = flavorIndex < 0 || canonicalFlavor(variant.options[flavorIndex]) === 'mixed-berry';
            const sizeMatches = sizeIndex < 0 || /\b90\b/.test(String(variant.options[sizeIndex] || ''));
            return flavorMatches && sizeMatches;
          });
        }

        if (targetVariant) {
          selected = targetVariant.options.slice();
        } else {
          // Preserve the user's requested visible selectors even if Shopify has not returned an
          // exact variant object yet. Do not silently fall back to 30 nights or another flavor.
          if (flavorIndex >= 0 && requestedFlavorValue) selected[flavorIndex] = requestedFlavorValue;
          if (sizeIndex >= 0 && requestedSizeValue) selected[sizeIndex] = requestedSizeValue;
        }

        function paintRequestedSelection() {
          offer.querySelectorAll('[data-option-index]').forEach((group) => {
            const index = Number(group.dataset.optionIndex);
            group.querySelectorAll('[data-option-value]').forEach((button) => {
              let active = button.dataset.optionValue === selected[index];
              if (group === flavorGroupEl && requestedFlavorValue) active = button.dataset.optionValue === requestedFlavorValue;
              if (group === sizeGroupEl && requestedSizeValue) active = button.dataset.optionValue === requestedSizeValue;
              button.classList.toggle('is-selected', active);
            });
          });
        }

        paintRequestedSelection();
        if (targetVariant) updateVariant();

        // Skio can re-render after the variant changes, so re-assert the requested visible
        // flavor/90-night state after those updates rather than allowing a stale 30-pack state.
        window.setTimeout(paintRequestedSelection, 80);
        window.setTimeout(paintRequestedSelection, 260);

        // Explicitly select Subscription and the 90-day cadence after the product variant sync.
        window.setTimeout(() => selectSubscriptionForCta(), 180);
        window.setTimeout(() => {
          updateSkioEnhancements();
          ensureDefaultFrequency(90);
          paintRequestedSelection();
        }, 460);
      }

      offer.addEventListener('cs2:select-purchase', (event) => {
        selectPurchaseFromCta(event.detail?.flavor || 'Mixed Berry');
      });

      function updateVariant() {
        let variant = findVariant();
        if (!variant) {
          variant = variants.find((item) => item.available) || variants[0];
          if (!variant) return;
          selected = variant.options.slice();
          offer.querySelectorAll('[data-option-index]').forEach((group) => {
            const index = Number(group.dataset.optionIndex);
            group.querySelectorAll('[data-option-value]').forEach((button) => {
              button.classList.toggle('is-selected', button.dataset.optionValue === selected[index]);
            });
          });
        }

        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        priceEls.forEach((el) => { el.textContent = money(variant.price); });
        compareEls.forEach((el) => {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            el.textContent = money(variant.compare_at_price);
            el.hidden = false;
          } else {
            el.hidden = true;
          }
        });
        if (submit) submit.disabled = !variant.available;
        updateAvailability();
        updateFlavorGallery();
        syncSkioVariant(variant);
        notifyVariantChanged(variant);
        lastFrequencyPack = null;
        window.setTimeout(updateSkioEnhancements, 100);
        window.setTimeout(updateSkioEnhancements, 300);
        window.setTimeout(syncStickyAtc, 320);
      }

      offer.addEventListener('click', (event) => {
        const optionButton = event.target.closest('[data-option-value]');
        if (optionButton && !optionButton.disabled) {
          const group = optionButton.closest('[data-option-index]');
          const index = Number(group.dataset.optionIndex);
          selected[index] = optionButton.dataset.optionValue;
          group.querySelectorAll('[data-option-value]').forEach((item) => item.classList.toggle('is-selected', item === optionButton));
          updateVariant();
          return;
        }

        const thumb = event.target.closest('[data-cs2-thumb]');
        if (thumb && mainImage && !thumb.hidden) {
          setMainImageFromThumb(thumb, true);
        }
      });

      updateVariant();
      initStickyAtc();
    });

    if (!document.documentElement.dataset.cs2PurchaseCtaBound) {
      document.documentElement.dataset.cs2PurchaseCtaBound = 'true';
      document.addEventListener('click', (event) => {
        const cta = event.target.closest('[data-cs2-purchase-cta]');
        if (!cta) return;
        const offerSection = document.querySelector('#cs2-offer.cs2-pdp-main');
        if (!offerSection) return;
        const offer = offerSection.querySelector('[data-cs2-offer]') || offerSection;
        event.preventDefault();
        event.stopPropagation();
        // The selector logic is initialized on the inner [data-cs2-offer] grid, so the
        // purchase event must be dispatched to that exact element. Dispatching it to
        // the outer section only scrolled the page and left the previous selections intact.
        offer.dispatchEvent(new CustomEvent('cs2:select-purchase', { detail: { flavor: cta.dataset.cs2Flavor || 'Mixed Berry' } }));
        const target = offerSection.querySelector('.cs2-pdp-main__intro') || offerSection;
        const top = target.getBoundingClientRect().top + window.scrollY - 16;
        window.scrollTo({ top, behavior: 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#cs2-offer');
      });
    }

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href="#cs2-offer"], a[href$="#cs2-offer"]');
      if (!link) return;
      const target = document.querySelector('#cs2-offer .cs2-lp-offer__intro .cs2-lp__eyebrow') || document.querySelector('#cs2-offer');
      if (!target) return;
      event.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 16;
      window.scrollTo({ top, behavior: 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#cs2-offer');
    });

    document.querySelectorAll('.cs2-home-proof__media').forEach((card) => {
      if (card.dataset.cs2UgcVideoInitialized === 'true') return;
      card.dataset.cs2UgcVideoInitialized = 'true';
      const video = card.querySelector('video.cs2-home-proof__media-video');
      const playButton = card.querySelector('[data-cs2-ugc-play]');
      const poster = card.querySelector('.cs2-home-proof__video-poster');
      if (!video) return;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const hasPoster = !!poster;
      card.classList.toggle('has-poster', hasPoster);

      if (hasPoster || isMobile) {
        video.controls = false;
        card.classList.remove('is-playing');
        if (playButton) playButton.hidden = false;
      } else {
        video.controls = true;
        card.classList.add('is-playing');
        if (playButton) playButton.hidden = true;
      }

      const startPlayback = () => {
        video.controls = true;
        card.classList.add('is-playing');
        if (playButton) playButton.hidden = true;
        if (poster) poster.hidden = true;
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      };

      if (playButton) playButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        startPlayback();
      });

      video.addEventListener('play', () => {
        video.controls = true;
        card.classList.add('is-playing');
        if (playButton) playButton.hidden = true;
        if (poster) poster.hidden = true;
      });
    });

    document.querySelectorAll('[data-cs2-testimonials]').forEach((section) => {
      if (section.dataset.reviewFiltersInitialized === 'true') return;
      section.dataset.reviewFiltersInitialized = 'true';

      const buttons = Array.from(section.querySelectorAll('[data-cs2-review-filter]'));
      const reviewItems = Array.from(section.querySelectorAll('.cs2-lp-testimonials__text-card[data-cs2-review-category]'));
      const textRail = section.querySelector('.cs2-lp-testimonials__text-rail');
      const mediaRail = section.querySelector('.cs2-lp-testimonials__rail');

      function updateRailCentering() {
        if (textRail) {
          const visibleTextCards = Array.from(textRail.querySelectorAll('.cs2-lp-testimonials__text-card')).filter((item) => !item.hidden);
          textRail.classList.toggle('is-centered-fit', visibleTextCards.length > 0 && visibleTextCards.length <= 4);
        }
        if (mediaRail) {
          const mediaCards = Array.from(mediaRail.querySelectorAll('.cs2-lp-testimonials__card')).filter((item) => !item.hidden);
          mediaRail.classList.toggle('is-centered-fit', mediaCards.length > 0 && mediaCards.length <= 4);
        }
      }

      updateRailCentering();
      if (!buttons.length || !reviewItems.length) return;

      function normalizeReviewKey(value) {
        return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      }

      function applyReviewFilter(key) {
        const normalizedKey = normalizeReviewKey(key) || 'all';
        buttons.forEach((button) => {
          const active = normalizeReviewKey(button.dataset.cs2ReviewFilter) === normalizedKey;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        reviewItems.forEach((item) => {
          const itemKey = normalizeReviewKey(item.dataset.cs2ReviewCategory) || 'all';
          item.hidden = normalizedKey !== 'all' && itemKey !== 'all' && itemKey !== normalizedKey;
        });
        updateRailCentering();
      }

      buttons.forEach((button) => {
        button.addEventListener('click', () => applyReviewFilter(button.dataset.cs2ReviewFilter));
      });

      const initial = buttons.find((button) => button.classList.contains('is-active')) || buttons[0];
      if (initial) applyReviewFilter(initial.dataset.cs2ReviewFilter);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLandingPage);
  else initLandingPage();
  document.addEventListener('shopify:section:load', initLandingPage);
})();
